import { render, staticRenderFns } from "./cropper_mobile.vue?vue&type=template&id=2622bb90&scoped=true&"
import script from "./cropper_mobile.vue?vue&type=script&lang=js&"
export * from "./cropper_mobile.vue?vue&type=script&lang=js&"
import style0 from "./cropper_mobile.vue?vue&type=style&index=0&id=2622bb90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2622bb90",
  null
  
)

export default component.exports